export default __webpack_public_path__ + "static/media/129.d38609cc.png";